/**
 * HEALTHCARE DOMAIN CONFIGURATION
 * Cấu hình cho lĩnh vực Y tế & Chăm sóc sức khỏe
 */
export const domainConfig = {
  // === BASIC INFO ===
  id: "healthcare",
  name: "Y tế & Chăm sóc sức khỏe",
  icon: "🏥",
  description:
    "Tạo nội dung marketing cho bệnh viện, phòng khám, spa và dịch vụ y tế",

  // === PROJECT TYPES ===
  projectTypes: {
    "Bệnh viện/Phòng khám": 1,
    "Nha khoa": 2,
    "Spa & Làm đẹp": 3,
    "Phòng gym & Fitness": 4,
    "Dược phẩm": 5,
    "Thiết bị y tế": 6,
    "Tư vấn sức khỏe online": 7,
    "Dịch vụ chăm sóc tại nhà": 8,
  },

  // === CONTENT TYPES ===
  contentTypes: {
    "Giới thiệu dịch vụ": 1,
    "Tư vấn sức khỏe": 2,
    "Chia sẻ kinh nghiệm bệnh nhân": 3,
    "Khuyến mãi/Ưu đãi": 4,
    "Thông tin bác sĩ/Chuyên gia": 5,
    "Mẹo chăm sóc sức khỏe": 6,
    "Thông tin bệnh lý": 7,
    "Event/Sự kiện y tế": 8,
    "Cam kết chất lượng": 9,
    "Testimonial khách hàng": 10,
  },

  // === PUBLISHING PLATFORMS (Optional) ===
  publishingPlatforms: {
    // Để trống sẽ dùng shared platforms
  },

  // === DEFAULT VALUES ===
  defaults: {
    projectType: "Bệnh viện/Phòng khám",
    contentType: "Giới thiệu dịch vụ",
    postLength: "Trung bình",
    postStyles: ["Chuyên nghiệp", "Đáng tin cậy"],
  },

  // === UI LABELS ===
  labels: {
    projectTypeLabel: "Loại hình y tế",
    contentTypeLabel: "Loại nội dung",
    projectInfoLabel: "Thông tin dịch vụ y tế",
    projectInfoPlaceholder:
      "Nhập thông tin chi tiết về dịch vụ, chuyên khoa, thiết bị, bác sĩ...",
    targetCustomerLabel: "Đối tượng bệnh nhân",
    targetCustomerPlaceholder:
      "Mô tả đối tượng khách hàng: độ tuổi, giới tính, tình trạng sức khỏe...",
  },

  // === DOMAIN-SPECIFIC SETTINGS ===
  settings: {
    requiresLocation: true, // Quan trọng cho y tế
    requiresPrice: false, // Giá y tế thường nhạy cảm
    requiresCertification: true, // Cần chứng chỉ hành nghề
    requiresExperience: true, // Kinh nghiệm bác sĩ/chuyên gia
  },
};
